export const POST_LOGIN = '/auth/login';
export const ADMIN_WORKSPACE_CONTEXT = '/admin/workspace-context';
export const PLATFORM_COMPANIES = '/platform/companies';
export const UPDATE_PASSWORD = '/auth/update-password';

export const FORGOT_PASSWORD = '/auth/forgot-password';
export const VERIFY_OTP = '/auth/verify-otp';
export const RESET_PASSWORD = '/auth/reset-password';

export const UPLOAD_FILE = '/upload';

// Contractor documents (#305 admin review surface). The ContractorDocument
// rows are owned per-contractor; admins can list and transition status, but
// only contractors can upload via the mobile app.
export const CONTRACTOR_DOCUMENTS = (contractorId: number | string): string =>
    `/contractors/${contractorId}/documents`;
export const CONTRACTOR_DOCUMENT_REVIEW_QUEUE = '/contractors/documents/review-queue';
export const CONTRACTOR_DOCUMENT_STATUS = (
    contractorId: number | string,
    docId: number | string
): string => `/contractors/${contractorId}/documents/${docId}/status`;
export const CONTRACTOR_DOCUMENT_FILE = (
    contractorId: number | string,
    docId: number | string
): string => `/contractors/${contractorId}/documents/${docId}/file`;

// Users
export const GET_USERS = '/users';
export const GET_USER = '/users';
export const DELETE_USER = '/users';
export const UPDATE_USER = '/users';
export const SEARCH_USERS = '/users/search';
export const CHANGE_PASSWORD = '/user/change-password';
export const BLOCK_USER = '/users/block';
export const GET_BLOCK_USER = '/users/blocked';
export const GET_NEW_APPLICANTS_COUNT = '/users/new-applicants-count';
export const GET_NEW_APPLICANTS = '/users/new-applicants';
export const APPROVE_REJECT_APPLICANT = '/users/approve-request-user';
export const SEARCH_NEW_APPLICANTS = '/users/search-new-applicants';

export const GET_USER_JOB_HISTORY = '/jobs/userJobsHistory';
export const GET_USER_FINANCIAL_HISTORY = '/jobs/userFinancialHistory';

// Contractor credentials (#307) — read-only admin surface; writes go through
// the contractor's own profile screens in the mobile app.
export const GET_CONTRACTOR_CREDENTIALS = '/contractors';

// Quotes
export const CREATE_QUOTE = '/quotes';
export const GET_QUOTES = '/quotes';
export const GET_QUOTES_HISTORY = '/quotes/history';
export const GET_LAST_EVENT_HISTORY = '/quotes/last-event-history';
export const GET_CLIENT_INVOICE_HISTORY = '/quotes/invoice/history';
export const GET_CANCELLED = '/quotes/cancelled';
export const GET_QUOTE_BY_ID = '/quotes';
// #872: token-gated client views (see backend /quotes|/actuals /client/:eventId).
export const GET_QUOTE_CLIENT = '/quotes/client';
export const CHANGE_QUOTE_STATUS = '/quotes/actions';
export const QUOTE_UPDATE_REQUEST = '/quotes/quote-update-request';
export const UPDATE_QUOTE = '/quotes';
export const UPDATE_EVENT_NOTES = '/quotes/notes';
export const DELETE_QUOTE = '/quotes';
export const CANCEL_EVENT = '/quotes/cancel';
export const PUBLISH_JOBS = '/quotes/publish-jobs';
export const SEND_DEPOSIT = '/quotes/sendDesposit';
export const MOVE_JOB_CHECK = '/quotes/move-jobs';


export const QUOTE_MOVE_JOB = '/quotes/quote-move-jobs';

export const CHECK_UPDATE_QUOTE = '/quotes/check-update-quote';

// export const CHANGE_PASSWORD = '/user/change-password';

// Shifts
export const GET_EVENTS = '/quotes/approved';
export const GET_SHIFTS = '/shifts/event';
export const ALREADY_HIRED = '/shifts/already-hired';
export const ASSIGN_SHIFTS_REQUEST = '/shifts/assignRequest';
export const ASSIGN_SHIFTS = '/shifts/assign';
export const ASSIGN_SHIFTS_BULK = '/shifts/bulkAssign';
export const ASSIGN_SHIFTS_REQUEST_BULK = '/shifts/bulkAssignRequest';
export const UNASSIGN_SHIFTS = '/shifts/unassign';
export const CANCEL_BID_PENDING_REQUEST = '/shifts/cancel-pending-request';
export const DELETE_SHIFT = '/shifts';
export const CREATE_LEAD = '/shifts/lead';
export const REMOVE_LEAD = '/shifts/lead/remove';
export const CANCEL_SHIFT = '/shifts/cancel';
export const SHIFT_CANCELLATION_REQUESTS = '/shift-cancellation-requests';
export const SHIFT_LATENESS_NOTICES = '/shift-lateness-notices';
export const ADD_USER_SHIFT = '/shifts/addUser';
export const ADD_EXTRA = '/shifts/addExtra';
export const GET_SHIFT_NUMBER = '/shifts/shiftNumber';
export const GET_UNLINKED_SHIFTS = '/shifts/unlink-shifts';
export const GET_UNLINKED_SHIFTS_OF_SHIFTS = '/shifts/unlink-shifts-of-shifts';
export const UPDATE_UNLINKED_SHIFT = '/shifts/update-unlink-shifts';
export const ASSIGN_UNLINK_SHIFT = '/shifts/assign-unlink-shift';

// Bids
export const GET_BIDS = '/bids/shift';
export const DELETE_BID = '/bids';
export const GET_ALL_BIDS_BY_EVENTID = '/bids/event';
export const MARK_BIDS_VIEWED_BATCH = '/bids/viewed/batch';

export const GET_JOBS = '/jobs/event';
export const FINANCIAL_STATEMENT = '/jobs/financialStatement';
export const GET_CONTRACTOR_INVOICE = '/jobs/contractorInvoice';
export const UPDATE_JOB = '/jobs';
export const UPDATE_JOB_NOTES = '/jobs/notes';
export const DELETE_JOB = '/jobs';
export const LAST_MINUTE_CANCELLATION = '/jobs/lastMinuteCancellation';
export const REMOVE_LAST_MINUTE_CANCELLATION =
  '/jobs/removeLastMinuteCancellation';
export const GET_EVENT_JOBS_USER = '/jobs/eventAndUserAdmin';
export const GET_EVENT_JOBS_USER_CONFIRMATION = '/jobs/userConfirmationJobs';
export const GET_SHIFT_REMINDERS = '/jobs/shift-reminders';
export const GET_PAYROLL = '/jobs/payroll';
export const UPDATE_PAYROLL_JOB = '/jobs/update-payroll-job';
export const INVOICE_UPDATE_REQUEST = '/jobs/invoice-update-request';

export const CREATE_INVOICE = '/attendances/createInvoice';
export const INVOICE_HISTORY = '/attendances/invoice-history';
export const APPROVE_INVOICE = '/attendances/approveOrRequest';
export const CANCEL_SENT_INVOICE = '/attendances/cancelSentInvoice';
export const CANCEL_APPROVED_INVOICE = '/attendances/cancel-approved-invoice';
export const GET_INVOICE_RECEIPTS_FOR_JOB = '/attendances/jobs';
export const ATTENDANCE_LOG = '/attendances/log';

export const CLINET_INVOICE_JOBS = '/jobs/clientInvoice';
export const REGENERATE_INVOICE_JOBS = '/jobs/regenerateClientInvoiceJobs';
export const CREATE_INVOICE_JOBS = '/jobs/clientInvoice';
export const CHANGE_INVOICE_JOBS = '/jobs/changeClientInvoiceStatus';
export const MERGE_INVOICE_JOBS = '/jobs/mergeClientInvoiceJobs';
export const DELETE_INVOICE_SHIFT = '/jobs/deleteInvoiceShift';
export const GET_SHIFT_USERS = '/jobs/getShiftUsers';
export const REMOVE_FROM_QUOTE = '/jobs/removeFromQuote';


export const GET_REFFERALS = '/refferal/fetch';
export const GET_FILTER_REFFERALS = '/refferal/filter';

export const ARCHIEVE_CHAT = '/chats/archive';

export const GET_ALL_CHATS = '/chats';
export const FIND_CHAT = '/chats/search';
export const GET_MESSAGES = '/messages/chat';
export const CREATE_MESSAGE = '/messages';
export const PIN_MESSAGE = '/messages/pin-message';
export const GET_CHATS_BY_USER = '/chats/shift-chats/list';
export const CHAT_DETAIL_BY_CHATID = '/chats/shift-chats/details';

// Chat platform v2 (Epic #393 / Sprint 4 / issue #419). These map to the
// Sprint 2 REST surface (`backend/src/modules/chat/controller/chat-rest.controller.ts`).
// The functions return path strings — callers pass them through the existing
// `APIClient` in `api_helper.ts`.
export const MY_CHATS = '/chats/me';
export const JOB_CHATS = (jobId: number | string): string =>
  `/chats/jobs/${jobId}`;
export const JOB_LEAD_DIRECT = (jobId: number | string): string =>
  `/chats/jobs/${jobId}/lead/direct`;
export const JOB_CONTRACTOR_DIRECT = (
  jobId: number | string,
  contractorId: number | string
): string => `/chats/jobs/${jobId}/contractors/${contractorId}/direct`;
export const JOB_GROUP_CREATE = (jobId: number | string): string =>
  `/chats/jobs/${jobId}/group`;
export const JOB_BROADCASTS = (jobId: number | string): string =>
  `/chats/jobs/${jobId}/broadcasts`;
export const JOB_BROADCAST_PREVIEW = (jobId: number | string): string =>
  `/chats/jobs/${jobId}/broadcasts/preview`;
export const CHAT_DETAIL = (chatId: number | string): string =>
  `/chats/${chatId}`;
export const CHAT_MESSAGES = (chatId: number | string): string =>
  `/chats/${chatId}/messages`;
export const CHAT_READ = (chatId: number | string): string =>
  `/chats/${chatId}/read`;
export const CHAT_ATTACHMENTS = (chatId: number | string): string =>
  `/chats/${chatId}/attachments`;
export const CHAT_ARCHIVE = (chatId: number | string): string =>
  `/chats/${chatId}/archive`;
export const MESSAGE_PIN = (id: number | string): string =>
  `/messages/${id}/pin`;
export const MESSAGE_DELETE = (id: number | string): string =>
  `/messages/${id}`;
export const SUPPORT_INBOX = '/chats/support';
export const SUPPORT_ASSIGN = (chatId: number | string): string =>
  `/chats/support/${chatId}/assign`;
export const SUPPORT_STATUS = (chatId: number | string): string =>
  `/chats/support/${chatId}/status`;
export const SUPPORT_NOTE = (chatId: number | string): string =>
  `/chats/support/${chatId}/internal-note`;
export const PLATFORM_SUPPORT_INBOX = '/platform/support-tickets';
export const PLATFORM_SUPPORT_DETAIL = (chatId: number | string): string =>
  `/platform/support-tickets/${chatId}`;
export const PLATFORM_SUPPORT_MESSAGES = (chatId: number | string): string =>
  `/platform/support-tickets/${chatId}/messages`;
export const PLATFORM_SUPPORT_ASSIGN = (chatId: number | string): string =>
  `/platform/support-tickets/${chatId}/assign`;
export const PLATFORM_SUPPORT_STATUS = (chatId: number | string): string =>
  `/platform/support-tickets/${chatId}/status`;
export const PLATFORM_SUPPORT_NOTE = (chatId: number | string): string =>
  `/platform/support-tickets/${chatId}/internal-note`;

// Attendance
export const CREATE_ATTENDANCE = '/attendances';
export const GET_ATTENDANCE = '/attendances/all';
export const DELETE_ATTENDANCE = '/attendances/delete';

export const SEND_NOW_NOTIFICATION = '/notifications/send-now';
export const SCHEDULE_NOTIFICATION = '/notifications/schedule';
export const CANCEL_SCHEDULE_NOTIFICATION = '/notifications/cancel-schedule';
export const GET_RECIPIENTS_BY_SCHEDULE_ID = '/notifications/get-recipients';
export const SEND_NOTIFICATION = '/notifications';
export const SEND_NOTIFICATION2 = '/quotes/anoucement';
export const SEND_MAIL = '/notifications/mail';
export const SEND_MAIL_TO_ALL = '/notifications/mailToAll';

export const GET_CALENDER = '/shifts/calender';

export const SEND_REMINDERS = '/jobs/reminders';
export const SEND_REMINDER_WITH_ATTACHMENT = '/jobs/reminders/with-attachment';
export const REMINDER_ATTACHMENT = (notificationId: number | string) => `/jobs/reminders/${notificationId}/attachment`;
export const CONFRIM_REMINDERS = '/jobs/confirmReminders';
export const UPDATE_EXTRA_CALL_TIME = '/jobs/update-extra-calltime';

export const GET_CONTACT_INFO = '/users/info';

export const POSITION = '/positions';
export const CATEGORY_GEAR = '/categories-gear';

// Role-based gear checklist (Feature 48, #322)
export const GEAR_ITEMS = '/gear-items';
// Role gear requirements live under positions/:positionId/gear-requirements/:reqId
export const POSITION_GEAR_REQUIREMENTS = (positionId: number | string) =>
  `/positions/${positionId}/gear-requirements`;

export const NOTIFICATIONS = '/notifications/admin';
export const UPDATE_NOTIFICATIONS = '/notifications';
export const MARK_ALL_READ_NOTIFICATIONS = '/notifications/markAllRead';

export const ROLES = '/roles';

export const ROLE_USERS = '/users/roles';
export const CREATE_ROLE_USER = '/users/roles';

export const GET_ACTUALS_BY_EVENT_ID = '/attendances/actuals';

export const FAQS = '/faqs';
export const CREATE_FAQS = '/faqs';
export const UPDATE_FAQS = '/faqs';
export const DELETE_FAQS = '/faqs';

export const POSITION_CATEGORIES = '/positions-categories';
export const POSITION_CATEGORIES_ORDER = '/positions-categories/order';

export const CREATE_ACTUALS = '/actuals';
export const GENERATE_ACTUALS = '/actuals/generate';
export const GET_ACTUALS = '/actuals';
export const GET_ACTUALS_CLIENT = '/actuals/client';
export const APPROVE_ACTUALS = '/actuals/approve';
export const REQUEST_TO_EDIT_ACTUALS = '/actuals/request';
export const DELETE_ACTUALS_SHIFT = '/actuals';
export const ACTUAL_MOVE_JOB = '/actuals/actualMoveJob';
export const ACTUAL_DRAG_AND_DROP_JOB = '/actuals/actualDragAndDropJob';

export const GET_COMPANY = '/companies';
export const UPDATE_COMPANY = '/companies';

// Per-company contractor-document requirements (#304).
export const COMPANY_DOCUMENT_REQUIREMENTS = (companyId: number | string) =>
  `/companies/${companyId}/document-requirements`;
export const COMPANY_DOCUMENT_REQUIREMENT_FOR_TYPE = (
  companyId: number | string,
  documentType: string
) => `/companies/${companyId}/document-requirements/${documentType}`;

// Per-company dress code options.
export const COMPANY_DRESS_CODES = (companyId: number | string) =>
  `/companies/${companyId}/dress-codes`;
export const COMPANY_DRESS_CODE_BY_ID = (
  companyId: number | string,
  dressCodeId: number | string
) => `/companies/${companyId}/dress-codes/${dressCodeId}`;



export const CREATE_EXPENSE = '/non-billable-expense';
export const GET_EXPENSES_BY_EVENT_ID = '/non-billable-expense/event';
export const DELETE_EXPENSE = '/non-billable-expense';
export const GET_INVOICE_NON_BILLABLE_EXPENSES =
  '/attendances/getInvoiceNonBillableExpenses';


export const GET_EMAIL_TEMPLATES = '/email-templates/type';
export const EMAIL_TEMPLATES = '/email-templates';
export const GET_TERMS_AND_SERVICES = '/terms-and-services/type';
export const TERMS_AND_SERVICES = '/terms-and-services';

// Bilateral post-shift reviews (#324, Feature 40)
export const SHIFT_CONTRACTOR_REVIEW = (shiftId: number | string) =>
  `/shifts/${shiftId}/contractor-reviews`;
export const SHIFT_VENUE_REVIEW = (shiftId: number | string) =>
  `/shifts/${shiftId}/venue-reviews`;
export const USER_CONTRACTOR_REVIEWS = (userId: number | string) =>
  `/users/${userId}/contractor-reviews`;

// Incident reports (issue #320 / Feature 50)
export const GET_INCIDENTS_FOR_EVENT = '/events';
export const UPDATE_INCIDENT = '/incidents';

// Venue intelligence (Feature 47, issue #321)
export const VENUES = '/venues';
